import { render, staticRenderFns } from "./Ft.vue?vue&type=template&id=38e0a616&"
import script from "./Ft.vue?vue&type=script&lang=js&"
export * from "./Ft.vue?vue&type=script&lang=js&"
import style0 from "./Ft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports